/// 統合「メンバー」一覧の entity store。ACC-7 (#361)。
///
/// メンバー画面 (`pages/members`) と組織詳細画面 (`pages/admin`) が購読する。一覧取得と
/// ローディング/エラー状態のみを持ち、判断は持たない (FSD: entities は store 担当)。
/// 両画面は同時表示されないため単一インスタンスを共有し、遷移時に必ず `refresh` する。

import { listMembers } from '@shared/api/members';
import type { Member } from '@shared/types/member';

class MemberListStore {
  items = $state<Member[]>([]);
  loading = $state(false);
  error = $state<string | null>(null);

  /// `organizationId` を渡すとその org の member だけに絞る (組織詳細画面)。未指定は
  /// role 由来の既定スコープ (メンバー画面)。
  async refresh(organizationId?: string): Promise<void> {
    this.loading = true;
    this.error = null;
    try {
      this.items = await listMembers(organizationId);
    } catch (err) {
      this.error = err instanceof Error ? err.message : String(err);
    } finally {
      this.loading = false;
    }
  }
}

export const memberListStore = new MemberListStore();
